<template>
	<div>
		<div class="banner">
			<el-carousel height="574px">
				<el-carousel-item v-for="(item,index) in banner" :key="item">
					<img :src="imgBaseUrl+item" alt="">
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="floor_third">
			<ul class="longe_list">
				<li class="item">
					<img :src="imgBaseUrl + detail.two_image_top" alt="">
					<div class="intro">
						<div class="title">{{detail.one_title}}</div>
						<div class="info">{{detail.two_text_top}}</div>
					</div>
				</li>
				<li class="item">
					<div class="intro">
						<div class="title">{{detail.two_title}}</div>
						<div class="info">{{detail.two_text_bottom}}</div>
					</div>
					<img :src="imgBaseUrl + detail.two_image_bottom" alt="">
				</li>
			</ul>
		</div>
		<div class="floor_four">
			<div class="first_title">Packages</div>
			<ul class="list">
				<li class="item" v-for="(item,index) in typeList" :key="index">
					<div class="picture_box">
						<img :src="imgBaseUrl +item.image" alt="">
					</div>
					
					<div class="intro">{{item.title}}</div>
					<div class="btn" @click="lookDetail(item)">More Info</div>
				</li>
			</ul>
		</div>
		<div class="floor_five">
			<div class="first_title">Benefits</div>
			<ul class="list">
				<li class="item" v-for="(item,index) in themeList" :key="index">
					<div class="picture_box">
						<img :src="imgBaseUrl + item.image" alt="">
					</div>
					<div class="name">{{item.title}}</div>
				</li>
			</ul>
		</div>
		<div class="floor_second">
			<div class="title">What is in our Bespoke packages</div>
			<ul class="list flex">
				<li class="item" v-for="(item,index) in classifyList" :key="item" >
					<div class="picture">
						<img :src="imgBaseUrl+item.image" alt="">
						<div class="tag">
							<div>{{item.title}}</div>
							
						</div>
					</div>
					<div class="info" >{{item.content}}</div>
				</li>
			</ul>
		</div>
		<div class="contact">
			<!-- <div v-html="detail.party"></div> -->
			<div class="first_title">Contact us</div>
			<div class="fileInfo_box">
				<div class="info_item">
					<input type="text" placeholder="Full name" v-model="name">
				</div>
				<div class="info_item">
					<input type="text" placeholder="Email" v-model="email">
				</div>
				<div class="info_item">
					<input type="text" placeholder="Mobile" v-model="contact">
				</div>
				<div class="info_item">
					<textarea placeholder="Your Message" v-model="content"></textarea>
				</div>
				<div class="submit" @click="feedback">Submit</div>
			</div>
		</div>
		<div class="model" v-if="selectModel" @click="selectModel = false">
			<div class="model_content" @click.stop="">
				<div class="detail" v-html="typeDetail"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				detail:{},
				banner:[],
				classifyList:[],
				typeList:[],
				themeList:[],
				content:'',
				contact:'',
				email:'',
				name:'',
				typeDetail:null,
				selectModel:false,
			}
		},
		mounted(){
			this.getClassify();
			this.getPartyBasics();
			this.getPartyThemes();
			this.getType();
		},
		methods:{
			lookDetail(item){
				this.typeDetail = item.content;
				this.selectModel = true;
				console.log(this.selectModel)
			},
			getClassify(){
				this.$api.post('Bespoke_Class/getBespokeClassProducts',{},res=>{
					if(res.code == 1){
						this.classifyList = res.data;
					}
				})
			},
			getType(){
				this.$api.post('Bespoke_Class/getBespokeClassTypes',{},res=>{
					if(res.code == 1){
						this.typeList = res.data;
					}
				})
			},
			getPartyThemes(){
				this.$api.post('Bespoke_Class/getBespokeClassThemes',{},res=>{
					if(res.code == 1){
						this.themeList = res.data;
					}
				})
			},
			getPartyBasics(){
				this.$api.post('Bespoke_Class/getBespokeClassBasics',{},res=>{
					if(res.code == 1){
						this.banner = res.data.ads.split(',');
						this.detail = res.data;
					}
				})
			},
			feedback(){
				var params = {
					content:this.content,
					contact:this.contact,
					email:this.email,
					name:this.name
				}
				this.$api.post('Bespoke_Class/bespokeClass',params,res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Successful'
						})
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			
		}
	}
</script>

<style lang="scss" scoped>
	.banner{
		width: 100%;
		height: 574px;
		
		img{
			width: 100%;
			height: 100%;
		}
		::v-deep .el-carousel__indicators--horizontal{
			display: block;
			
		}
		::v-deep .el-carousel__indicator--horizontal button{
			display: block;
			width: 8px;
			height: 8px;
			background: #FFFFFF;
			opacity: 0.3;
			border-radius: 50%;
			padding: 0 ;
			margin-right: 30px;
		}
		::v-deep .el-carousel__indicator--horizontal.is-active button{
			opacity: 1;
		}	
	}
	.floor_third{
		width: 1200px;
		margin: 0 auto;
		margin-top: 40px;
		.longe_list{
			.item{
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 40px;
				text-align: left;
				.intro{
					width: 661px;
					.title{
						font-size: 22px;
						font-family: Source Han Sans CN;
						font-weight: bold;
						color: #282E30;
						margin-bottom: 19px;
					}
					.info{
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						line-height: 30px;
						text-align: left;
					}
					.btn{
						margin-top: 20px;
					}
				}
				img{
					width: 500px;
					height: 300px;
				}
			}
		}
	}
	.floor_four{
		width: 1200px;
		margin: 0 auto;
		margin-top: 40px;
		.first_title{
			font-size: 22px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #282E30;
			margin-bottom: 19px;
			text-align: center;
		}
		.list{
			width: 100%;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			.item{
				width: 380px;
				margin-right: 20px;
				margin-bottom: 20px;
				.picture_box{
					width: 100%;
					height: 380px;
					overflow: hidden;
					border-radius: 10px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.intro{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
					margin-bottom: 10px;
				}
				.btn{
					width: 182px;
					height: 58px;
					background: #5C707A;
					border-radius: 29px;
					line-height: 58px;
					text-align: center;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #F7F2EB;
					margin: 0 auto;
					cursor: pointer;
				}
			}
		}
	}
	.floor_five{
		width: 1200px;
		margin: 0 auto;
		margin-top: 40px;
		.first_title{
			font-size: 22px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #282E30;
			margin-bottom: 19px;
		}
		.list{
			width: 100%;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			.item{
				width: 120px;
				margin-right: 20px;
				margin-bottom: 20px;
				.picture_box{
					width: 120px;
					height: 120px;
					overflow: hidden;
					border-radius: 50%;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.name{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
					text-align: center;
				}
				
			}
		}
	}
	.floor_second{
		width: 1200px;
		margin: 0 auto;
		padding-top: 77px;
		.title{
			font-size: 22px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #282E30;
			margin-bottom: 24px;
		}
		.second_title{
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			line-height: 36px;
			text-align: left;
		}
		.list{
			flex-wrap: wrap;
			margin-bottom: 10px;
			.item{
				width: 290px;
				margin-right: 13px;
				margin-bottom: 30px;
				cursor: pointer;
				.picture{
					width: 100%;
					height: 260px;
					border-radius: 10px;
					overflow: hidden;
					position: relative;
				}
				img{
					width: 100%;
					height: 100%;
				}
				.tag{
					width: 100%;
					height: 50px;
					background-color: rgba(255,255,255,0.8);
					position: absolute;
					left: 0;
					bottom: 0;
					line-height: 30px;
					text-align: center;
					font-size: 16px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #BF5F49;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					div{
						text-align: center;
					}
				}
				
				.info{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					line-height: 30px;
					color: #282E30;
					margin-top: 17px;
					text-align: left;
				}
				&:nth-child(4n+0){
					margin-right: 0;
				}
			}
		}
		
	}
	.contact{
		width: 1200px;
		margin: 0 auto;
		padding: 20px;
		.first_title{
			font-size: 26px;
			font-weight: bold;
			color: #282E30;
			text-align: center;
		}
		.fileInfo_box{
			width: 100%;
			background: #F7F2EB;
			// box-shadow: 0px -17px 18px 0px rgba(35,24,21,0.0400);
			// border-radius: 10px;
			padding: 50px 30px;
			.info_item{
				margin-bottom: 30px;
				input{
					width: 100%;
					height: 80px;
					background: #F7F2EB;
					border: 1px solid #CCCCCC;
					border-radius: 20px;
					padding: 0 30px;
					line-height: 80px;
					font-size: 24px;
					font-family: PingFangSC;
					font-weight: 500;
					color: #999999;
					line-height: 80px;
				}
				textarea{
					width: 100%;
					height: 200px;
					background: #F7F2EB;
					border: 1px solid #CCCCCC;
					border-radius: 20px;
					padding: 27px 30px;
					font-size: 24px;
					font-family: PingFangSC;
					font-weight: 500;
					color: #999999;
					line-height: 30px;
					outline: none;
				}
			}
		}
		.submit{
			width: 500px;
			height: 88px;
			background: #5C707A;
			box-shadow: 0px 2px 7px 0px rgba(0,0,0,0.2000);
			border-radius: 20px;
			margin:0 auto;
			font-size: 30px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #F7F2EB;
			line-height: 88px;
			text-align: center;
			cursor: pointer;
		}
	}
	.model{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background: rgba(0,0,0,0.2);
		z-index: 99;
		.model_content{
			width: 750px;
			height: 80%;
			background: #F7F2EB;
			box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
			border-radius: 10px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			padding: 30px;
			overflow-y: scroll;
		}
		
	}
</style>